import Tabbar from './tabbar'
import TabbarItem from './tabbar-item'

export {
  Tabbar,
  TabbarItem
}



// WEBPACK FOOTER //
// ./~/.0.1.3@vux/src/components/tabbar/index.js